module.exports = __webpack_public_path__ + "static/media/modes.5141a68d.gif";